import { EnvironmentType } from './environment.type';

export const environment: EnvironmentType = {
  production: false,
  apiUrl: 'https://0wnqtf746f.execute-api.eu-central-1.amazonaws.com/dev/api',
  apiCode: '',
  environmentId: 'dev',
  msalClientId: '6eb92815-d83a-43d6-a3f9-8cc958063880',
  msalRedirectUri: 'https://app.dev.impliancy.com/login-msal',
  msalAuthority: 'https://login.microsoftonline.com/common',
  useServiceWorkers: true,
  showEmailLogin: false,
  waitBeforeEnvSyncMins: 20
};
